export default __webpack_public_path__ + "static/media/logo-coinbase.d2735050.svg";